import React from 'react';
import { Icon } from 'Permafrost/index';
import { StyledAccordion } from './Accordion.styles';
export const Accordion = (props) => {
    const { className, content, header, id, open, notes } = props;
    return (React.createElement(StyledAccordion, { className: className, id: id, open: open, "data-cy": props['data-cy'] },
        React.createElement("summary", null,
            React.createElement("div", { className: "header-container" },
                React.createElement(Icon, { className: "toggle-icon", name: "chevron-up", size: [14] }),
                header ? React.createElement("h2", null, header) : null,
                notes ? React.createElement("span", { className: "header-container-notes" }, notes) : null)),
        React.createElement("div", { className: "content" }, content)));
};
//# sourceMappingURL=Accordion.js.map